module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "justifications"
    }
  }, [(this.arrayJustify.length > 0) ? _c('v-client-table', {
    staticClass: "data-table custom-data-table",
    attrs: {
      "data": _vm.justifications,
      "columns": _vm.columns,
      "options": _vm.options
    },
    scopedSlots: _vm._u([{
      key: "acoes",
      fn: function(props) {
        return [_c('div', {
          staticClass: "actions"
        }, [_c('button', {
          staticClass: "fa fa-times action",
          staticStyle: {
            "color": "#4a4a4a"
          },
          on: {
            "click": function($event) {
              return _vm.removeJustify(props.row)
            }
          }
        })])]
      }
    }], null, false, 1653133628)
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2dcfce74", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2dcfce74"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/reports/manualConciliation/justifications.pug
// module id = 1390
// module chunks = 0